import { NavigateRoutes } from 'common/constants/app.constant';
import { BaseDataModel, FormMetaModel, HeaderList } from '../../utilitymodels/base.model';

export class ActivationOpportuinityItem {
    name: string;
    img: string;
    url: string;
    investorList: [];
    schemeList: [];
    text: string;
    remText?: string;
    pageTitle: string;
    toolTipData: string;
    headerList: HeaderList[] = [];
    rowList: string[] = [];
    actionName: string;
    deepLink: boolean = false;
}

// Investors have been  inactive

// Investors have zero balance folio
const activationUrl = {
    inactive: NavigateRoutes.activationOpportunityList + '/inactive',
    zerobalance: NavigateRoutes.activationOpportunityList + '/zerobalance',
};

export class ActivationOpportunityModel extends BaseDataModel {
    listInfo: ActivationOpportuinityItem[] = [
        {
            name: 'Inactive Investors',
            img: 'assets/icon/card/inactive-investor.svg',
            investorList: [],
            schemeList: [],
            url: activationUrl.inactive,
            text: '',
            pageTitle: 'Inactive Investors',
            toolTipData: ' This report helps you with the list of all the investors who are inactive / made no new investment with you in the last 6 months',
            headerList: [
                {
                    name: 'Investor Details',
                    logo: 'assets/icon/reports/sip-report/user.svg',
                },
                {
                    name: 'Folio Creation Date',
                    logo: 'assets/icon/card/calendar-remove.svg',
                },

                {
                    name: 'Last Date Of Investment',
                    logo: 'assets/icon/card/calendar-remove.svg',
                },
                {
                    name: 'No. Of Schemes',
                    logo: 'assets/icon/card/schemes.svg',
                },
                {
                    name: 'Actions',
                    logo: '',
                },
            ],
            rowList: ['Investor_Name', 'Folio_Creation_Date', 'Last_Investment_Date'],
            actionName: 'TRANSACT',
            deepLink: false,
        },
        {
            name: 'Zero Balance',
            img: 'assets/icon/card/balance-folio.svg',
            investorList: [],
            schemeList: [],
            url: activationUrl.zerobalance,
            text: 'Folios with',
            pageTitle: 'Zero Balance Folios',
            toolTipData: 'This report helps you with the list of all the investors whose current AUM with you is zero.',
            headerList: [
                {
                    name: 'Investor Details',
                    logo: 'assets/icon/reports/sip-report/user.svg',
                },
                {
                    name: 'Folio Creation Date',
                    logo: 'assets/icon/card/calendar-remove.svg',
                },

                {
                    name: 'Last Transaction Date',
                    logo: 'assets/icon/card/calendar-remove.svg',
                },
                {
                    name: 'Actions',
                    logo: '',
                },
            ],
            rowList: ['Investor_Name', 'Date_of_Folio_Creation', 'Last_Date_Of_Transaction'],
            actionName: 'TRANSACT',
            deepLink: false,
        },
    ];
    errorModel: any[] = [];
    // sipCeased = [];
    // sipNotRenewed = [];
    // sipMaturity = [];
    // sipRejected = [];
}

export class ActivationOpportunityMetaModel extends FormMetaModel {
    constructor() {
        super('Activation Opportunities', '', false, NavigateRoutes.oppotunity);
    }

    initProperties() {
        return {};
    }
}
